<template>
  <v-content>
    <v-portal-tool-bar/>
    <v-container
      fluid>
      <v-row
        justify=center>
        <v-col
          cols=auto
          md=10>
          <v-privacy-policy/>
        </v-col>
      </v-row>
    </v-container>
    <v-portal-footer/>
  </v-content>
</template>

<script>
import VPortalToolBar from '@/components/organisms/portal/VPortalToolBar.vue'
import VPrivacyPolicy from '@/components/organisms/portal/VPrivacyPolicy.vue'
import VPortalFooter from '@/components/organisms/portal/VPortalFooter.vue'
export default {
  components: {
    VPortalToolBar,
    VPrivacyPolicy,
    VPortalFooter
  }
}
</script>
